import PreviousStepButton from './previous-step-button.vue';

export default PreviousStepButton;
